module.exports = "https://bin.bnbstatic.com/_next/static/images/sure-cancel-49c0d424830de11a495349d3936155bd.svg";